import * as React from "react";
import type { SVGProps } from "react";
const SvgFire = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 21c-3.86 0-7-3.14-7-7 0-2.04.9-4.27 2.28-5.7l.13-.14c1.15-1.18 2.58-2.64 2.58-5.17 0-.4.24-.77.62-.92.37-.16.8-.07 1.09.22 1.18 1.18 3.07 5.01 1.65 8.3.18-.05.73-.34 1.78-2.1a.997.997 0 0 1 1.6-.15c1.07 1.2 2.25 3.82 2.25 5.67 0 3.86-3.14 7-7 7zm-.53-15.13c-.65 1.67-1.78 2.83-2.63 3.69l-.13.13c-1.03 1.05-1.72 2.78-1.72 4.3 0 2.76 2.24 5 5 5s5-2.24 5-5c0-.88-.45-2.18-.99-3.19-.8 1.08-1.54 1.62-2.33 1.76-1.01.17-1.8-.37-2.31-.79-.4-.33-.48-.9-.19-1.33.95-1.41.77-3.18.3-4.57"
    />
  </svg>
);
export default SvgFire;
